import { IonSpinner } from "@ionic/react";
import { apiRequest } from "shared/api/apiRequest";
import { getSocietyProfileAccountingInvoiceGeneratePdfContract } from "shared/api/contracts/society/societyId/profiles/profileId/accounting/invoice/invoiceId/generatePdf";
import PillarForm from "shared/components/pillar-form/PillarForm";
import { useCustomSession } from "shared/context/CustomSessionContext";
import usePDFDownload from "hub/src/hooks/usePDFDownload";
import { useHubCheckoutContext } from "hub/src/pages/checkout/context/HubCheckoutContext";

export const HubCheckoutPrintInvoiceButton = () => {
  const session = useCustomSession();
  const { invoice } = useHubCheckoutContext();
  const invoicePdf = usePDFDownload(async (invoiceId, profileId) =>
    apiRequest({
      contract: getSocietyProfileAccountingInvoiceGeneratePdfContract,
      inputs: {
        params: {
          societyId: session.societyId!,
          profileId: profileId,
          invoiceId: invoiceId,
        },
      },
    }),
  );
  return (
    <div className="flex justify-between">
      <div className="text-title">Order Summary</div>
      {invoicePdf.isLoading ? (
        <IonSpinner className="h-5 w-5" />
      ) : (
        <PillarForm.Button
          className="button-regular-general-filled w-fit whitespace-nowrap"
          onClick={() =>
            invoicePdf.downloadPDF(
              Number(invoice!.invoiceId),
              session.profileId!,
            )
          }
        >
          Print Invoice
        </PillarForm.Button>
      )}
    </div>
  );
};
